import React, { useState, useEffect } from "react";
import {
  getDatabase,
  ref,
  onValue,
  set,
  push,
  update,
} from "firebase/database";
import "./JambQuestionsPage.css";

const JambQuestionsPage = () => {
  const db = getDatabase();
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState({
    question: "",
    answer: "",
    year: "",
    options: {
      0: "",
      1: "",
      2: "",
      3: "",
    },
  });

  useEffect(() => {
    const subjectsRef = ref(db, "JAMB/fields/subjects");
    onValue(subjectsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setSubjects(Object.keys(data));
      }
    });
  }, [db]);

  const handleSubjectSelect = (subject) => {
    setSelectedSubject(subject);
    const questionsRef = ref(db, `JAMB/fields/subjects/${subject}/questions`);
    onValue(questionsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setQuestions(Object.entries(data).map(([id, q]) => ({ id, ...q })));
      } else {
        setQuestions([]);
      }
    });
  };

  const handleAddQuestion = async (e) => {
    e.preventDefault();
    if (
      !selectedSubject ||
      !newQuestion.question ||
      !newQuestion.answer ||
      !newQuestion.year ||
      !newQuestion.options[0] ||
      !newQuestion.options[1] ||
      !newQuestion.options[2] ||
      !newQuestion.options[3]
    ) {
      alert("Please fill in all fields, including options.");
      return;
    }

    try {
      const questionsRef = ref(
        db,
        `JAMB/fields/subjects/${selectedSubject}/questions`
      );
      const newQuestionRef = push(questionsRef);
      await set(newQuestionRef, newQuestion);
      alert("Question added successfully.");
      setNewQuestion({
        question: "",
        answer: "",
        year: "",
        options: { 0: "", 1: "", 2: "", 3: "" },
      });
    } catch (error) {
      console.error("Error adding question:", error);
      alert("Failed to add question.");
    }
  };

  const handleEditQuestion = async (id, updatedQuestion) => {
    try {
      const questionRef = ref(
        db,
        `JAMB/fields/subjects/${selectedSubject}/questions/${id}`
      );
      await update(questionRef, updatedQuestion);
      alert("Question updated successfully.");
    } catch (error) {
      console.error("Error updating question:", error);
      alert("Failed to update question.");
    }
  };

  const handleDeleteQuestion = async (id) => {
    try {
      const questionRef = ref(
        db,
        `JAMB/fields/subjects/${selectedSubject}/questions/${id}`
      );
      await set(questionRef, null); // Deletes the question
      alert("Question deleted successfully.");
    } catch (error) {
      console.error("Error deleting question:", error);
      alert("Failed to delete question.");
    }
  };

  return (
    <div className="jamb-questions-container">
      <h1 className="jamb-questions-title">JAMB Questions Management</h1>
      <div className="subject-selector">
        <h2>Select a Subject</h2>
        <ul className="subject-list">
          {subjects.map((subject) => (
            <li
              key={subject}
              className={`subject-item ${
                selectedSubject === subject ? "selected" : ""
              }`}
              onClick={() => handleSubjectSelect(subject)}
            >
              {subject}
            </li>
          ))}
        </ul>
      </div>

      {selectedSubject && (
        <div className="questions-section">
          <h2>Questions for {selectedSubject}</h2>
          <ul className="questions-list">
            {questions.map((q) => (
              <li key={q.id} className="question-item">
                <strong>Question:</strong> {q.question} <br />
                <strong>Answer:</strong> {q.answer} <br />
                <strong>Year:</strong> {q.year} <br />
                <strong>Options:</strong> <br />
                <ul>
                  {Object.entries(q.options).map(([key, value]) => (
                    <li key={key}>
                      <strong>Option {parseInt(key) + 1}:</strong> {value}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() =>
                    handleEditQuestion(q.id, {
                      question:
                        prompt("Edit question:", q.question) || q.question,
                      answer: prompt("Edit answer:", q.answer) || q.answer,
                      year: prompt("Edit year:", q.year) || q.year,
                    })
                  }
                >
                  Edit
                </button>
                <button onClick={() => handleDeleteQuestion(q.id)}>Delete</button>
              </li>
            ))}
          </ul>

          <form className="add-question-form" onSubmit={handleAddQuestion}>
            <h3>Add a New Question</h3>
            <div className="form-group">
              <label>Question:</label>
              <input
                type="text"
                value={newQuestion.question}
                onChange={(e) =>
                  setNewQuestion({ ...newQuestion, question: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>Answer:</label>
              <input
                type="text"
                value={newQuestion.answer}
                onChange={(e) =>
                  setNewQuestion({ ...newQuestion, answer: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>Year:</label>
              <input
                type="text"
                value={newQuestion.year}
                onChange={(e) =>
                  setNewQuestion({ ...newQuestion, year: e.target.value })
                }
              />
            </div>
            <div className="form-group">
              <label>Options:</label>
              <div className="options-group">
                <input
                  type="text"
                  placeholder="Option 1"
                  value={newQuestion.options[0]}
                  onChange={(e) =>
                    setNewQuestion({
                      ...newQuestion,
                      options: { ...newQuestion.options, 0: e.target.value },
                    })
                  }
                />
                <input
                  type="text"
                  placeholder="Option 2"
                  value={newQuestion.options[1]}
                  onChange={(e) =>
                    setNewQuestion({
                      ...newQuestion,
                      options: { ...newQuestion.options, 1: e.target.value },
                    })
                  }
                />
                <input
                  type="text"
                  placeholder="Option 3"
                  value={newQuestion.options[2]}
                  onChange={(e) =>
                    setNewQuestion({
                      ...newQuestion,
                      options: { ...newQuestion.options, 2: e.target.value },
                    })
                  }
                />
                <input
                  type="text"
                  placeholder="Option 4"
                  value={newQuestion.options[3]}
                  onChange={(e) =>
                    setNewQuestion({
                      ...newQuestion,
                      options: { ...newQuestion.options, 3: e.target.value },
                    })
                  }
                />
              </div>
            </div>
            <button type="submit">Add Question</button>
          </form>
        </div>
      )}
    </div>
  );
};

export default JambQuestionsPage;
